import AssessmentIcon from '@material-ui/icons/Assessment';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Avatar from '@material-ui/core/Avatar';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CategoryIcon from '@material-ui/icons/Category';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DescriptionIcon from '@material-ui/icons/Description';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import GetAppIcon from '@material-ui/icons/GetApp';
import GroupIcon from '@material-ui/icons/Group';
import HomeIcon from '@material-ui/icons/Home';
import LayersIcon from '@material-ui/icons/Layers';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import NoteIcon from '@material-ui/icons/Note';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import PlaceIcon from '@material-ui/icons/Place';
import React from 'react';
import SupervisedUserIcon from '@material-ui/icons/SupervisedUserCircle';
import { Tooltip } from '@material-ui/core';
import { LinkComponent, LogoutComponent } from '../Global/LinkComponents';
import canUserAccess from '../../utils/canUserAcces';
import { getUserInitials } from '../../utils/tools';

export const MainListItems = ({ user }) => {
  const { userType } = user || false;

  return (
    <>
      <ListItem button component={LinkComponent} href={userType === 'SSSF Administrator' ? '/admin' : '/'}>
        <ListItemIcon>
          {/* <Badge
            badgeContent=''
            color='error'
            variant='dot'
            {...(upcommingEvents > 0 ? '' : 'showZero')}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          > */}
          <Tooltip title='Home' placement='top'>
            <HomeIcon />
          </Tooltip>
          {/* </Badge> */}
        </ListItemIcon>
        <ListItemText primary='Home' />
      </ListItem>
      {user.tableau && (
        <ListItem button component={LinkComponent} href='/dashboards'>
          {/* <ListItem button component={LinkComponent} href={'#'}> */}
          <ListItemIcon>
            <Tooltip title='Dashboards' placement='top'>
              <DashboardIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Dashboards' />
        </ListItem>
      )}
      {canUserAccess(user, '/patients') && (
        <ListItem button component={LinkComponent} href='/patients'>
          <ListItemIcon>
            <Tooltip title='Patients' placement='top'>
              <LocalHospitalIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Patients' />
        </ListItem>
      )}
      {canUserAccess(user, '/entries') && (
        <ListItem button component={LinkComponent} href='/entries'>
          <ListItemIcon>
            <Tooltip title='Entries' placement='top'>
              <AssignmentIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Entries' />
        </ListItem>
      )}

      <ListItem button component={LinkComponent} href='/issues'>
        <ListItemIcon>
          <Tooltip title='QA Issues' placement='top'>
            <ErrorOutlineIcon />
          </Tooltip>
        </ListItemIcon>
        <ListItemText primary='QA Issues' />
      </ListItem>

      {canUserAccess(user, '/users') && (
        <ListItem button component={LinkComponent} href='/users'>
          <ListItemIcon>
            <Tooltip title='Users' placement='top'>
              <GroupIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Users' />
        </ListItem>
      )}
      {canUserAccess(user, '/study-groups') && (
        <ListItem button component={LinkComponent} href='/study-groups'>
          <ListItemIcon>
            <Tooltip title='Groups' placement='top'>
              <SupervisedUserIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Groups' />
        </ListItem>
      )}
      {canUserAccess(user, '/studies') && (
        <ListItem button component={LinkComponent} href='/studies'>
          <ListItemIcon>
            <Tooltip title='Studies' placement='top'>
              <NoteIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Studies' />
        </ListItem>
      )}
      {canUserAccess(user, '/sites') && (
        <ListItem button component={LinkComponent} href='/sites'>
          <ListItemIcon>
            <Tooltip title='Sites' placement='top'>
              <PlaceIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Sites' />
        </ListItem>
      )}
      {canUserAccess(user, '/surgeons') && (
        <ListItem button component={LinkComponent} href='/surgeons'>
          <ListItemIcon>
            <Tooltip title='Surgeons' placement='top'>
              <PeopleAltIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Surgeons' />
        </ListItem>
      )}
      {canUserAccess(user, '/form/templates') && (
        <ListItem button component={LinkComponent} href='/form/templates'>
          <ListItemIcon>
            <Tooltip title='Form Templates' placement='top'>
              <DescriptionIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Form Templates' />
        </ListItem>
      )}
      {canUserAccess(user, '/embedded-reports') && (
        <ListItem button component={LinkComponent} href='/embedded-reports'>
          <ListItemIcon>
            <Tooltip title='Embedded Reports' placement='top'>
              <AssessmentIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Embedded Reports' />
        </ListItem>
      )}
      {canUserAccess(user, '/import') && (
        <ListItem button component={LinkComponent} href='/import'>
          <ListItemIcon>
            <Tooltip title='Import' placement='top'>
              <LayersIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Import Data' />
        </ListItem>
      )}
      {canUserAccess(user, '/export') && (
        <ListItem button component={LinkComponent} href='/export'>
          <ListItemIcon>
            <Tooltip title='Export' placement='top'>
              <GetAppIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Export Data' />
        </ListItem>
      )}
      {canUserAccess(user, '/patient-types') && (
        <ListItem button component={LinkComponent} href='/patient-types'>
          <ListItemIcon>
            <Tooltip title='Patient Types' placement='top'>
              <CategoryIcon />
            </Tooltip>
          </ListItemIcon>
          <ListItemText primary='Patient Types' />
        </ListItem>
      )}
    </>
  );
};
export const UserListItems = (props) => (
  <>
    <ListItem button component={LinkComponent} href='/my-account'>
      <ListItemIcon>
        <Tooltip title='My Account' placement='top'>
          {props.user && <Avatar className='userIcon'>{getUserInitials(props.user.name)}</Avatar>}
        </Tooltip>
      </ListItemIcon>
      <ListItemText primary='My Account' />
    </ListItem>
    <ListItem button component={LogoutComponent} href='/logout'>
      <ListItemIcon>
        <Tooltip title='logout' placement='top'>
          <ExitToAppIcon />
        </Tooltip>
      </ListItemIcon>
      <ListItemText primary='Logout' />
    </ListItem>
  </>
);
